<div class="inner-pages properties-list h-100 listing agents hp-6 full hd-white no-scroll-menu">
  <section class="properties-right h-100 list featured portfolio mobile-portfolio-list blog pt-5">
    <div class="container">
      <div [ngClass]="{
          'map-view-active': stateView == 'map',
          'no-properties': total === 0 && properties.length === 0
        }" class="row properties-top-data">
        <div class="col-lg-8 col-md-12 blog-pots">
          <section class="headings-2 my-2 pt-0 pb-2">
            <div class="pro-wrapper">
              <div
                class="cod-pad single detail-wrapper mr-2 mt-0 d-flex justify-content-md-end align-items-center grid">
                <!-- <button [disabled]="networkStatus === 0" (click)="openOffCanvas(filterOffCanvas)" mat-raised-button
                  [ngClass]="{ filtered: propertyFiltered }" class="filter-button border shadow-none">
                  <ion-icon *ngIf="networkStatus === 1" class="filter-icon"
                    src="assets/new-icons/options-outline.svg"></ion-icon>
                  <ion-icon *ngIf="networkStatus === 0" class="filter-icon"
                    src="assets/new-icons/cloud-offline-outline.svg"></ion-icon>{{ "t-filter" | translate }}
                </button> -->
                <div class="sorting-options">
                  <a (click)="changeLayout('list')" [ngClass]="
                      stateView == 'list' ? 'active-view-btn' : 'desactive-view'
                    " class="change-view-btn lde ms-0"><i class="fa fa-th-list"></i></a>
                  <a (click)="changeLayout('grid')" [ngClass]="
                      stateView == 'grid' ? 'active-view-btn' : 'desactive-view'
                    " class="change-view-btn"><i class="fa fa-th-large"></i></a>
                  <a *ngIf="mapProperties" (click)="changeLayout('map')" [ngClass]="
                      stateView == 'map' ? 'active-view-btn' : 'desactive-view'
                    " class="change-view-btn"><i class="fa fa-map-o"></i></a>
                </div>
              </div>
            </div>
          </section>
          <div class="no-results-properties" *ngIf="total === 0 && properties?.length === 0">
            <div class="no-results-icon">
              <ion-icon src="assets/new-icons/remove-circle-outline.svg"></ion-icon>
            </div>
            <div class="no-results-text d-flex">
              <span class="text-center">{{ "t-no-results-1" | translate }}
                <a (click)="clearFilters()" routerLink="/properties">{{
                  "t-no-results-2" | translate
                  }}</a></span>
            </div>
          </div>
          <app-grid-view *ngIf="stateView == 'grid'" [properties]="properties"></app-grid-view>
          <app-list-view *ngIf="stateView == 'list'" [properties]="properties"></app-list-view>
          <app-map-view *ngIf="stateView == 'map'" [properties]="properties"></app-map-view>
          <div *ngIf="isBottomList.value && networkStatus === 1" class="mobile-loading">
            <div class="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="status-mes"></div>
          </div>
          <div *ngIf="
              properties &&
              properties.length > 0 &&
              properties?.length === this.total &&
              networkStatus === 1
            " class="align-items-center all-results d-grid justify-content-center mb-5 pb-3 pt-2">
            <div class="d-flex all-results-icon justify-content-center fs-1">
              <ion-icon src="assets/new-icons/search-circle-outline.svg"></ion-icon>
            </div>
            <span>{{ "t-all-results" | translate }}</span>
          </div>
          <div *ngIf="networkStatus === 0"
            class="align-items-center all-results d-grid justify-content-center mb-5 pb-3 pt-2">
            <div class="d-flex offline-results-icon justify-content-center fs-1">
              <ion-icon src="assets/new-icons/cloud-offline-outline.svg"></ion-icon>
            </div>
            <span>{{ "t-offline-results" | translate }}</span>
          </div>
          <div class="white-space"></div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="float-btn">
  <button [disabled]="networkStatus === 0" (click)="openOffCanvas(filterOffCanvas)"
    [ngClass]="{ filtered: propertyFiltered, 'filters-opened': filtersOpened }"
    class="filter-button border shadow-none">
    <ion-icon *ngIf="networkStatus === 1" class="filter-icon" src="assets/new-icons/options-outline.svg"></ion-icon>
    <ion-icon *ngIf="networkStatus === 0" class="filter-icon"
      src="assets/new-icons/cloud-offline-outline.svg"></ion-icon>
  </button>
</div>
<!-- Mobile Filters -->
<ng-template #filterOffCanvas let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-basic-title">
      {{ "t-filters" | translate }}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeOffCanvas(filterOffCanvas)"></button>
  </div>
  <div class="offcanvas-body">
    <form>
      <div class="mb-3 row">
        <div *ngIf="initFilters" class="explore__form-checkbox-list search-home">
          <div class="row">
            <div class="col-12 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  <ion-icon class="me-2" name="bookmark-outline"></ion-icon>{{ "t-reference" | translate }}
                </div>
                <input [(ngModel)]="searchForm.reference" [ngModelOptions]="{ standalone: true }" type="text"
                  class="form-control" placeholder="{{ 't-reference' | translate }}" />
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  <ion-icon src="assets/new-icons/swap-vertical-outline.svg" class="me-2"></ion-icon>{{ "t-order-by" |
                  translate }}
                </div>
                <ng-select [clearable]="false" placeholder="{{ 't-order-by' | translate }}" [(ngModel)]="sortingValue"
                  [searchable]="false" [items]="sortingOptions" name="order-by" [compareWith]="compareFn"
                  (change)="orderChange()" bindValue="value">
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | translate }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-12 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  {{ "t-district" | translate }}
                </div>
                <ng-select (change)="districtChange()" [(ngModel)]="selectedDistrict"
                  [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let district of searchData.locations" [value]="
                      district.countryId +
                      '-' +
                      district.id +
                      '-' +
                      district.regionId
                    ">{{ district.name }}</ng-option>
                </ng-select>
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-12 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  {{ "t-county" | translate }}
                </div>
                <ng-select (change)="countyChange()" [(ngModel)]="selectedCounty"
                  [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let c of county" [value]="c.id">{{ c.name }}</ng-option>
                </ng-select>
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-12 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  {{ "t-parish" | translate }}
                </div>
                <ng-select [(ngModel)]="selectedParish" [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let p of parish" [value]="p.id">{{ p.name }}</ng-option>
                </ng-select>
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Property Status -->
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2" src="assets/new-icons/briefcase-outline.svg"></ion-icon>{{
                  "FILTERS.BUSINESS.TEXT" | translate }}
                </div>
                <ng-select [(ngModel)]="searchForm.businessType" [searchable]="false"
                  [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let bType of searchData.businessType" [value]="bType.id">{{ bType.name
                    }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <div class="form-group categories">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2" src="assets/new-icons/business-outline.svg"></ion-icon>{{
                  "FILTERS.PROPERTY-TYPE.TEXT" | translate }}
                </div>
                <ng-select [(ngModel)]="searchForm.propertyType" [searchable]="false"
                  [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let pType of searchData.propertyType" [value]="pType.id">{{ pType.name
                    }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <div class="form-group categories">
                <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                  <ion-icon class="me-2" src="assets/new-icons/construct-outline.svg"></ion-icon>{{
                  "FILTERS.PROPERTY-STATE.TEXT" | translate }}
                </div>
                <ng-select [(ngModel)]="searchForm.propertyCondition" [searchable]="false"
                  [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                  <ng-option *ngFor="let sType of searchData.propertyCondition" [value]="sType.id">{{ sType.name
                    }}</ng-option>
                </ng-select>
              </div>
              <!--/ End Form Property Status -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pr-30 pl-0">
              <!-- Form Bedrooms -->
              <div class="form-group beds">
                <div class="filter-title mb-2">
                  <ion-icon class="me-2" src="assets/new-icons/bed-outline.svg"></ion-icon>{{ "FILTERS.BEDROOMS.TEXT" |
                  translate }}
                </div>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button
                      [ngClass]="{'active': (!searchForm.bedrooms || searchForm.bedrooms == null) && searchForm.bedrooms != '0'}"
                      value="" class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                      type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                      {{ "FILTERS.ANY.TEXT" | translate }}
                    </button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bedrooms == '0'}" value="0" class="nav-link"
                      id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                      role="tab" aria-controls="pills-profile" aria-selected="false">
                      0
                    </button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bedrooms == '1'}" value="1" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      1
                    </button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bedrooms == '2'}" value="2" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      2
                    </button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bedrooms == '3'}" value="3" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      3
                    </button>
                  </li>
                  <li class="nav-item me-1 beds-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bedrooms == '4'}" value="4" class="nav-link beds-last"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      4+
                    </button>
                  </li>
                </ul>
              </div>
              <!--/ End Form Bedrooms -->
            </div>
            <div class="col-lg-4 col-md-6 py-1 pl-0 pr-30">
              <!-- Form Bathrooms -->
              <div class="form-group bath">
                <div class="filter-title mb-2">
                  <i class="fa fa-bath me-2" aria-hidden="true"></i>{{ "FILTERS.BATHROOMS.TEXT" | translate }}
                </div>
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button
                      [ngClass]="{'active': (!searchForm.bathrooms || searchForm.bathrooms == null) && searchForm.bathrooms != '0'}"
                      value="" class="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
                      type="button" role="tab" aria-controls="pills-home" aria-selected="true">
                      {{ "FILTERS.ANY.TEXT" | translate }}
                    </button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bathrooms == '0'}" value="0" class="nav-link"
                      id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                      role="tab" aria-controls="pills-profile" aria-selected="false">
                      0
                    </button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bathrooms == '1'}" value="1" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      1
                    </button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bathrooms == '2'}" value="2" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      2
                    </button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bathrooms == '3'}" value="3" class="nav-link"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      3
                    </button>
                  </li>
                  <li class="nav-item me-1 bath-items" role="presentation">
                    <button [ngClass]="{'active': searchForm.bathrooms == '4'}" value="4" class="nav-link bath-last"
                      id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                      role="tab" aria-controls="pills-contact" aria-selected="false">
                      4+
                    </button>
                  </li>
                </ul>
              </div>
              <!--/ End Form Bathrooms -->
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 py-1 pr-30 mr-5 sld">
              <!-- Price Fields -->
              <div class="main-search-field-2">
                <!-- Area Range -->
                <div>
                  <label><ion-icon class="me-2" src="assets/new-icons/resize-outline.svg"></ion-icon>{{
                    "FILTERS.AREA-RANGE.TEXT" | translate }} (m²)</label>
                  <div class="d-flex align-items-center mt-1 gap-1">
                    <input [ngModelOptions]="{ standalone: true }" (change)="inputChange('area')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="areaValue" />
                    <span>-</span>
                    <input [ngModelOptions]="{ standalone: true }" (change)="inputChange('area')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="areaMaxValue" />
                  </div>
                  <div class="clearfix"></div>
                </div>
                <br />
                <!-- Price Range -->
                <div>
                  <label><ion-icon class="me-2" src="assets/new-icons/cash-outline.svg"></ion-icon>{{
                    "FILTERS.PRICE-RANGE.TEXT" | translate }}</label>
                  <div class="d-flex align-items-center mt-1 gap-1">
                    <input [ngModelOptions]="{ standalone: true }" (change)="inputChange('price')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="priceValue" />
                    <span>-</span>
                    <input [ngModelOptions]="{ standalone: true }" (change)="inputChange('price')" type="number"
                      class="form-control border-input w-50 area-value" [(ngModel)]="priceMaxValue" />
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 py-1 pr-30 mb-4">
              <!-- Checkboxes --><label><ion-icon class="me-2 mt-2" name="build-outline"></ion-icon>{{
                "FILTERS.CHARACTERISTICS.TEXT" | translate }}</label>
              <div class="checkboxes mt-0 one-in-row margin-bottom-10 ch-1 row">
                <div *ngFor="let char of searchData.characteristics; let i = index" class="col-6">
                  <ng-container *ngIf="i <= 5">
                    <input [checked]="checkedCharacteristics.includes(char.id)" (change)="updateChars(char.id)"
                      id="check-char-{{ char.id }}" type="checkbox" name="check" />
                    <label for="check-char-{{ char.id }}">{{
                      char.name
                      }}</label>
                  </ng-container>
                </div>
                <div *ngIf="!moreChar && searchData.characteristics.length > 4" class="col-12 mt-3">
                  <div class="more-char-button align-items-center d-flex fs-6 justify-content-center">
                    <a class="d-flex align-items-center main-color" (click)="moreChar = true"><ion-icon
                        src="assets/new-icons/add-circle-outline.svg" class="me-1"></ion-icon>{{ "t-more-chars" |
                      translate }}</a>
                  </div>
                </div>
              </div>
              <div *ngIf="moreChar && searchData.characteristics.length > 6"
                class="checkboxes one-in-row margin-bottom-10 row">
                <div *ngFor="let char of searchData.characteristics; let i = index" class="col-6">
                  <ng-container *ngIf="i > 5">
                    <input [checked]="checkedCharacteristics.includes(char.id)" (change)="updateChars(char.id)"
                      id="check-char-{{ char.id }}" type="checkbox" name="check" />
                    <label for="check-char-{{ char.id }}">{{
                      char.name
                      }}</label>
                  </ng-container>
                </div>
                <div class="col-12 mt-3">
                  <div class="more-char-button align-items-center d-flex fs-6 justify-content-center">
                    <a (click)="moreChar = false"><ion-icon src="assets/new-icons/remove-circle-outline.svg"
                        class="me-1"></ion-icon>{{ "t-less-chars" | translate }}</a>
                  </div>
                </div>
              </div>
              <!-- Checkboxes / End -->
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="text-end properties-filter">
      <button type="button" class="btn btn-clear w-25 me-2 d-inline-flex align-items-center float-start"
        (click)="clearFilters()">
        <span class="me-1">{{ "FILTERS.CLEAR.TEXT" | translate }}</span>
        <ion-icon class="fs-5" src="assets/new-icons/close-outline.svg"></ion-icon>
      </button>
      <button type="button" class="btn btn-outline-dark w-25 float-end" (click)="filterProperties(filterOffCanvas)">
        {{ "t-filter" | translate }}
      </button>
    </div>
  </div>
</ng-template>
